module.exports = __webpack_public_path__ + "static/img/partner-marie.215f158.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-marie.png
// module id = muRn
// module chunks = 34